import { render, staticRenderFns } from "./CounselingList.vue?vue&type=template&id=51de671a&scoped=true"
import script from "./CounselingList.vue?vue&type=script&lang=js"
export * from "./CounselingList.vue?vue&type=script&lang=js"
import style0 from "./CounselingList.vue?vue&type=style&index=0&id=51de671a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de671a",
  null
  
)

export default component.exports